var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-frame-warning"},[_c('span',{staticStyle:{"font-size":"14px","color":"#606266"}},[_vm._v(_vm._s(this.$l('table_scm_name') || '工厂'))])])}
var staticRenderFns = []

export { render, staticRenderFns }